<template>
    <div :id="validateId"></div>
</template>

<script>
const loginLan=  {
    phonePlaceholder: 'Moblie Phone Number',
    codePlaceholder: 'Verification code',
    getCode: 'Get code',
    gettingCode: 'Getting',
    reGetCode: 'Retry',
    login: 'Log In or Register',
    loginTopic: 'By signing up you agree to the',
    loginTopicPrivacy: 'Privacy Policy',
    loginTopicAnd: 'and',
    loginTopicRegister: 'Term of Use ',
    friendInvite: 'Invitation code (optional)',
    emailPlaceholder: 'Enter your email',
    setPassword: 'Password (letters + nums + chars)',
    agreeText: 'Please read and check the registration agreement',
    passwordErr: 'Password does not meet requirements',
    phoneError: 'Please enter the correct mobile phone number',
    imgCodeTip: 'Please enter the characters displayed in the image',
    imgCodeAnswer: 'Please enter the answer to the equation',
    codeTip: 'Unclear? Change another',
    imgCodeInput: 'Please enter',
    confirm: 'Confirm',
    cancel: 'Cancel',
    slideTip: 'Drag the pieces atop one another',
    loginInfo: '',
    logout: 'Log Out'
};
import { wySafeCheckout } from '@/common/middleware'
export default {
    data() {
        return {
            captchaIns: null,
            currentLang: window.navigator.language.includes('zh'),
        }
    },
    mounted() {
        this.loginSafeHandle()
    },
    props: {
        validateId: String,
    },
    methods: {
        // 网易登录安全校验
        loginSafeHandle() {
            wySafeCheckout().then(() => {
                let _this = this;
                // 若使用降级方案引用初始化js
                // initNECaptcha替换成initNECaptchaWithFallback
                if(!this.captchaIns){
                    window.initNECaptcha({
                        captchaId: 'a015b2e038c94edcae85e046e7a5b744',
                        element: '#captcha',
                        mode: 'popup',
                        width: '320px',
                        feedbackEnable: false, // 业务方关闭反馈入口
                        lang: this.currentLang ? 'zh-CN' : 'en',
                        customTexts: {
                            slideTip: loginLan.slideTip,
                        },
                        onVerify: function (err, data) {
                            /**
                             * 第一个参数是err（Error的实例），验证失败才有err对象
                             * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
                             * {
                             *   validate: 'xxxxx' // 二次验证信息
                             * }
                            **/
                            if (err) return // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
                            // 点击登录按钮后可调用服务端接口，以下为伪代码，仅作示例用
                            _this.$emit('getSafeValidate', data.validate);
                        }
                    }, function onload (instance) {
                        _this.captchaIns = instance
                    }, function onerror (err) {
                        // 初始化失败后触发该函数，err对象描述当前错误信息
                        console.log(err)
                    })
                }
            })
        },
        loginSafeShow(){
            if (this.captchaIns) {
                this.captchaIns && this.captchaIns.popUp()
            }
        },
        refresh() {
            if (this.captchaIns) {
                this.captchaIns.refresh()
            }
        }
    },
}
</script>
<style lang="scss" >
.yidun_control{ // 修改验证码提示文字默认
    padding-left: 60px !important;
}
</style>
